// extracted by mini-css-extract-plugin
export default {"sidebar_wrap":"style_sidebar_wrap__5MwaB"};